// src/post-template-variation.js

import { registerBlockStyle } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';

export const registerBlockbiteStyles = (blockStyles) => {
  blockStyles.map((style) => {
    registerBlockStyle(style.name, [
      {
        name: style.style_handle,
        label: style.label,
      },
    ]);
  });
};
